import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TopNavigation from '../../components/TopNavigation';
import AboutHeroSection from './components/AboutHeroSection';
import FoundingTeamSection from './components/FoundingTeamSection';
import FounderProfileSection from './components/FounderProfileSection';
import PartnersSection from './components/PartnersSection';
import HighlightsSection from './components/HighlightsSection';
import AboutCTASection from './components/AboutCTASection';
import Footer from '../../components/Footer';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About - Sleeve</title>
        <meta
          name="description"
          content="Learn about Sleeve's mission to make hardware accessible, collaborative, and secure. Meet our founding team and discover our partnerships with industry leaders."
        />
        <meta name="keywords" content="Sleeve, about, founding team, mission, hardware development, engineering" />
        <meta property="og:title" content="About - Sleeve" />
        <meta property="og:description" content="Built by engineers, for engineers. Meet the team behind Sleeve and learn about our mission." />
      </Helmet>

      <TopNavigation />

      <main className="min-h-screen bg-background">
        <AboutHeroSection />
        <FoundingTeamSection />
        <FounderProfileSection />
        <PartnersSection />
        <HighlightsSection />
        <AboutCTASection />
      </main>

      <Footer />
    </>
  );
};

export default About;